import { useMemo } from 'react';

// material-ui
import Box from '@mui/material/Box';

// project imports
import Profile from './Profile'; // Use our simplified profile
import DrawerHeader from 'layout/Dashboard/Drawer/DrawerHeader';

// ==============================|| COMPANY SELECTION HEADER CONTENT ||============================== //

export default function CompanySelectionHeaderContent() {
  return (
    <>
      {/* Logo section */}
      <DrawerHeader open={true} />

      {/* Spacer to push profile to the right */}
      <Box sx={{ width: '100%', ml: 1 }} />

      {/* Only show simplified profile dropdown */}
      <Profile />
    </>
  );
}
